import { render } from "./BasicToggle.vue?vue&type=template&id=ef65b3a4&scoped=true"
import script from "./BasicToggle.vue?vue&type=script&lang=js"
export * from "./BasicToggle.vue?vue&type=script&lang=js"

import "./BasicToggle.vue?vue&type=style&index=0&id=ef65b3a4&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef65b3a4"]])

export default __exports__